import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { CoreModal } from 'components/ModalViewV3';
import TextView from 'components/TextView';
import useChannelDetails from 'hooks/useChannelDetails';
import {
  IContent,
  TemplateContent,
  postTemplateCreation,
  resetContent,
} from 'redux/content/content.slice';
import { RootState } from 'redux/store/store';

import { YbCoreButton } from '@yubi/yb-core-button-v3';

import { ContentStatus } from './ContentTemplate';

interface IModalProps {
  open: boolean;
  onClose: React.Dispatch<React.SetStateAction<boolean>>;
  content: IContent;
}
export function isArrayOfObjectsEmpty(arr: TemplateContent[]): boolean {
  if (arr.length === 0) {
    return false;
  }
  const obj = arr[0];
  if (
    !obj.language ||
    (!obj.message && !obj.rawText) ||
    (!obj.templateId &&
      !obj.flowId &&
      (!obj.fromAddress || !obj.fromName || !obj.subject))
  ) {
    return false;
  }

  return true;
}

function DiscardModel({ open, onClose, content }: IModalProps) {
  const dispatch = useDispatch();
  const nav = useNavigate();
  const { channel } = useChannelDetails();
  const onSubmit = () => {
    onClose(false);
    dispatch(resetContent());

    nav(`/settings/content/channels/${channel}/overview`);
  };
  const contentName = useSelector(
    (state: RootState) => state.content.content.name
  );

  return (
    <CoreModal
      open={open}
      onDismiss={() => onClose(false)}
      onModalClose={() => onClose(false)}
    >
      <div className="flex flex-col items-center pt-[36px] gap-4">
        <div className=" flex flex-col items-center gap-2">
          <TextView
            color="#101828"
            weight="700"
            size={16}
            fontStyle="normal"
            lineHeight={24}
            text={'Discard current template?'}
          />
          <TextView
            color="#475467"
            weight="400"
            size={14}
            fontStyle="normal"
            lineHeight={20}
            text="Please save changes if you'd like to refer to it again later."
          />
        </div>
        <div className="flex gap-2 px-6 items-center">
          <div className="w-full">
            <YbCoreButton
              size="m"
              variant="tertiary"
              label="Save as Draft"
              disabled={
                !(contentName && isArrayOfObjectsEmpty(content.details))
              }
              onClick={() => {
                const postTemplateCreationCallBack = () => {
                  onClose(false);
                  nav(`/content/channels/${channel}/overview`);
                };

                if (contentName) {
                  const contentsDetails = content.details?.map(
                    (contentItem) => {
                      return {
                        ...contentItem,
                        status: ContentStatus.DRAFT,
                      };
                    }
                  );
                  return dispatch(
                    postTemplateCreation({
                      content: { ...content, details: contentsDetails },
                      channel,
                      postTemplateCreationCallBack,
                      status: ContentStatus.DRAFT,
                    })
                  );
                }
              }}
            />
          </div>
          <div className="w-[280px]">
            <YbCoreButton
              size="m"
              variant="primary"
              label="Discard Template"
              onClick={onSubmit}
            />
          </div>
        </div>
      </div>
    </CoreModal>
  );
}

export default DiscardModel;
